import React, { Fragment, useState } from "react";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { MdEmail } from "react-icons/md"
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import Delete from "./delete";
import Edit from "./edit";
import { Button } from "styled";
import { BiCloudDownload, BiDownload } from "react-icons/bi";
import axios from "apis/axios";
import Email from "./email";

const ViewList = ({ data, index, approveRequest,getData,page }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false)
  const currentUser = useSelector((state) => state.user.currentUser);
  // console.log(currentUser.userRole.permissions)
  // console.log(checkPermission( [permissions.edit_dtp], currentUser))
  // const download = async()=>{
  //   const response = await createDocument("manage-dtp/findOne", {id: data._id});
  //   if(response?.data) setDoc({...response?.data, fleet: response?.data.fleet._id, hub: response?.data.hub._id, points: response?.data?.points.map(point=> point._id)})

  // }

  const download = async () => {
    const url = `manage-dtp/findOne`;

    //download file from that url
    const response = await axios.post(url, {
      id: data._id,
      download: 1,},
      {
      responseType: "blob",
      
    });

    const url2 = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url2;
    link.setAttribute("download", "manage_dtp.pdf");
    document.body.appendChild(link);
    link.click();
  };

  console.log("data--", data);

  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{(page-1)*20 + index + 1}</TD>
        <TD>
          {data.createdAt ? new Date(data.createdAt).toLocaleDateString("en-GB") : ""}
        </TD>
        <TD>{data.fleet?.fleetName}</TD>
        <TD>{data.hub?.hubName}</TD>
        <TD>{data.trainerName}</TD>
        <TD>{data.participants}</TD>
        {/* <TD>
          {data.createdAt ? new Date(data.createdAt).toLocaleDateString("en-GB") : ""}
        </TD> */}
        <TD>{data.createdBy?.name}</TD>
        <TD>
          {(
            <div className="flex flex-row">
              {checkPermission( [permissions.edit_dtp], currentUser) ? <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>: 
              <div className= "px-1 flex justify-center align-center mt-2"></div>}
              <button
                onClick={async () => {
                  await download();
                }}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <BiCloudDownload />
              </button>
              {checkPermission( [permissions.delete_dtp], currentUser) ? <button
                onClick={() => setShowDeleteModel(true)}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button>: <div className= "px-1 flex justify-center align-center mt-2"></div>}

              {checkPermission( [permissions.send_email_dtp], currentUser) ? <button
                onClick={() => setShowEmailModal(true)}
                className="p-2  m-1 rounded-md bg-blue-500 hover:bg-blue-600 text-white"
              >
                <MdEmail />
              </button>: <div className= "px-1 flex justify-center align-center mt-2"></div>}
              
            </div>
          )}
        </TD>
      </tr>
      {showEditModel && (
        <Edit data={data} handleClick={() => {setShowEditModel(false); getData();}} />
      )}

      {showEmailModal && (
        <Email data={data} handleClick={() => setShowEmailModal(false)} />
      )}

      {showDeleteModel && (
        <Delete
          id={data._id}
          handleClick={() => setShowDeleteModel(false)}
          getData={getData}
        />
      )}
    </Fragment>
  );
};

export default ViewList;
